import { useMatiApiClient } from './client'
import { useQuery } from '@maui/react-query'

export const useEodSummary = (options = {}) => {
  const api = useMatiApiClient('eod')
  return useQuery({
    queryFn: () => api.fetchSummary(),
    queryKey: ['eod-summary'],
    refetchOnWindowFocus: false,
    ...options
  })
}

export const useEodCases = (options = {}) => {
  const api = useMatiApiClient('eod')
  return useQuery({
    queryFn: () => api.fetchCases(),
    queryKey: ['eod-cases'],
    refetchOnWindowFocus: false,
    ...options
  })
}
export const useEodCaseById = (id, options = {}) => {
  const api = useMatiApiClient('eod')
  return useQuery({
    queryFn: () => api.fetchCaseById(id),
    queryKey: ['eod-cases', id],
    refetchOnWindowFocus: false,
    ...options
  })
}
